import Icon from 'components/Icon'
import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import InfoPopover from './InfoPopover'
import { Category } from './lists/CategoryList'
import { CreateTag } from '../generated/graphql'

const S = {
    InfoIconWrapper: styled.div`
        position: relative;
        height: 100%;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        cursor: pointer;
        &:after {
            content: '';
            position: absolute;
            height: 20px;
        }
    `,
}

interface Props {
    category: Category
    fetchData: () => void
    deleteCategory: (id: number) => Promise<any>
    createTag:(data: CreateTag) => Promise<any>
    updateCategory: (id, text) => Promise<any>
}

const MoreOptionsButton = ({
    category, fetchData, deleteCategory, createTag, updateCategory
}: Props) => {
    const buttonRef = useRef<HTMLDivElement>()
    const [show, setShow] = useState(false)
    return (
        <S.InfoIconWrapper
            ref={buttonRef}
            onClick={() => setShow(!show)}
            onMouseLeave={() => setShow(false)}
        >
            <Icon size={18} icon="drag" />
            {show && (
                <InfoPopover
                    deleteCategory={deleteCategory}
                    direction="down"
                    category={category}
                    fetchData={fetchData}
                    createTag={createTag}
                    updateCategory={updateCategory}
                />
            )}
        </S.InfoIconWrapper>
    )
}

export default MoreOptionsButton
